<template>
  <BaseChart
    dark
    height="250px"
    chart-height="150px"
    title="Price development in original currency"
    :chart-data="mergedChartData"
    :subtitle="subtitle"
  >
    <template #widget-options>
      <slot name="widget-options"></slot>
    </template>
  </BaseChart>
</template>

<script>
import { commonPropertiesMixin } from './common-properties-mixin'
import { xAxis, yAxis, chart } from '@/reusable/base-chart/chart-data'

const customChartData = {
  chart: chart(),
  xAxis: xAxis({ lineColor: '#9A9FAE' }, 'white'),
  yAxis: yAxis({}, 'white', undefined, '#9A9FAE'),
  plotOptions: {
    series: {
      color: 'white',
      marker: {
        radius: 6
      }
    }
  }
}

export default {
  mixins: [commonPropertiesMixin('price-development-in-original-currency', customChartData)],

  computed: {
    subtitle() {
      if (!this.supportData) return 'Original currency'
      return `Original currency (${this.supportData.merge_data['[[ CURRENCY ]]']})`
    }
  }
}
</script>
